import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";

import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AccountPage from "@/pages/AccountPage";
import WishlistPage from "@/pages/WishlistPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ServicePage from "@/pages/ServicePage";
import RentalPage from "@/pages/RentalPage";
import BrandsPage from "@/pages/BrandsPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminRentals from "@/pages/admin/AdminRentals";
import AdminServices from "@/pages/admin/AdminServices";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminFeeds from "@/pages/admin/AdminFeeds";
import AdminImport from "@/pages/admin/AdminImport";
import AdminPasswordResets from "@/pages/admin/AdminPasswordResets";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import OrderConfirmationPage from "@/pages/OrderConfirmationPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <CartProvider>
              <Toaster position="top-right" richColors />
              <Routes>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="categories" element={<AdminCategories />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="rentals" element={<AdminRentals />} />
                  <Route path="services" element={<AdminServices />} />
                  <Route path="suppliers" element={<AdminSuppliers />} />
                  <Route path="messages" element={<AdminMessages />} />
                  <Route path="feeds" element={<AdminFeeds />} />
                  <Route path="import" element={<AdminImport />} />
                  <Route path="password-resets" element={<AdminPasswordResets />} />
                </Route>
                <Route path="*" element={
                  <Layout>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/shop" element={<ShopPage />} />
                      <Route path="/shop/:category" element={<ShopPage />} />
                      <Route path="/product/:slug" element={<ProductPage />} />
                      <Route path="/cart" element={<CartPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                      <Route path="/payment/success" element={<PaymentSuccessPage />} />
                      <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                      <Route path="/order/confirmed/:id" element={<OrderConfirmationPage />} />
                      <Route path="/account" element={<AccountPage />} />
                      <Route path="/wishlist" element={<WishlistPage />} />
                      <Route path="/blog" element={<BlogPage />} />
                      <Route path="/blog/:slug" element={<BlogPostPage />} />
                      <Route path="/service" element={<ServicePage />} />
                      <Route path="/rental" element={<RentalPage />} />
                      <Route path="/brands" element={<BrandsPage />} />
                      <Route path="/about" element={<AboutPage />} />
                      <Route path="/contact" element={<ContactPage />} />
                    </Routes>
                  </Layout>
                } />
              </Routes>
            </CartProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
